import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export const FAQSection = () => {
  const faqs = [
    {
      question: "Is this just another newsletter that tells me what to buy?",
      answer: "No. And the distinction matters. Stock newsletters send you picks. Payne's Education teaches you the framework behind the decisions. By the time you complete your first few weeks, you will not be waiting for someone to tell you what to buy. You will have the analytical foundation to evaluate opportunities yourself. That is the entire point of the program, and it is why we describe it as education rather than a subscription service."
    },
    {
      question: "I have been burned by investing services before. Why is this different?",
      answer: "That experience is more common than most people admit, and we take it seriously. Three things make Payne's Education structurally different. First, Charles's credibility is anchored to a daily national television program where his analysis is on the record every market day. Second, the program is built around framework development, not pick delivery. Third, the $7 trial exists specifically so you can verify the value for yourself before committing to anything further. We are not asking you to trust us. We are asking you to test us."
    },
    {
      question: "Will this work if I am not an experienced investor?",
      answer: "Yes. The program is designed to work across experience levels. The Foundation Lessons and orientation sequence are built to take someone starting from zero through to a confident, system-based approach. The live Q and A sessions mean no question goes unanswered at any stage. Members include complete beginners, investors managing mid-size brokerage accounts, and people approaching retirement who want a more structured framework than they have been using."
    },
    {
      question: "What happens after the $7 trial ends?",
      answer: "Your membership continues at $99 per month. You can cancel at any time, including during the trial, with no penalty. If you cancel during the 30-day trial, you receive a full $7 refund. The Tax Strategies for Investors bonus is yours to keep regardless of when you cancel."
    }
  ];

  return (
    <section 
      data-testid="faq-section"
      className="section-padding px-8 md:px-12 bg-gray-50"
    >
      <div className="max-w-3xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-12"
        >
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-[2px] bg-amber-600" />
            <p className="font-sans text-xs tracking-widest uppercase text-gray-400">
              Questions
            </p>
          </div>
          
          <h2 className="font-editorial text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-4">
            Questions We Hear{' '}
            <span className="text-amber-600">Before People Join</span>
          </h2>
          <p className="font-sans text-lg text-gray-600">
            Here are honest answers to the questions we hear most often from people considering the trial.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-0">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                data-testid={`faq-item-${index}`}
                className="border-b border-gray-200 hover:border-amber-600 transition-colors group"
              >
                <AccordionTrigger className="font-editorial text-lg md:text-xl text-gray-900 text-left py-6 hover:no-underline hover:text-amber-600 transition-colors font-bold [&[data-state=open]]:text-amber-600">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="font-sans text-base text-gray-600 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
